module.exports = __webpack_public_path__ + "src/images/products/trendsetter/113_Baker Slim-Fit Camouflage- Print Cotton Shorts.png";